module.exports = __webpack_public_path__ + "img/wechat.b6390705.png";